(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("html-parse-stringify"), require("unescape-html"), require("escape-html"), require("cr-numeral"));
	else if(typeof define === 'function' && define.amd)
		define(["html-parse-stringify", "unescape-html", "escape-html", "cr-numeral"], factory);
	else if(typeof exports === 'object')
		exports["allchanMarkup"] = factory(require("html-parse-stringify"), require("unescape-html"), require("escape-html"), require("cr-numeral"));
	else
		root["allchanMarkup"] = factory(root["html-parse-stringify"], root["unescape-html"], root["escape-html"], root["cr-numeral"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__915__, __WEBPACK_EXTERNAL_MODULE__286__, __WEBPACK_EXTERNAL_MODULE__907__, __WEBPACK_EXTERNAL_MODULE__822__) => {
return 